import { Fetcher } from "@cloudflare/workers-types";

export let imageFetcher: typeof fetch | Fetcher["fetch"] = fetch;

export const setImageFetch = (imgFetch?: Fetcher): void => {
  if (imgFetch)
    imageFetcher = (request: Parameters<Fetcher["fetch"]>[0]) => imgFetch?.fetch(request);
};
